import React, { useEffect } from 'react';
import { Settings } from 'lucide-react';
import PageShell from '../common/PageShell.jsx';
import heroVedio from '../../assets/algo hero.mp4'; // Desktop video
import mobileHeroVedio from '../../assets/algo hero mobile.mp4'; // IMPORT YOUR MOBILE VIDEO HERE

const Algorithm = () => {
  useEffect(() => {
    document.title = 'ALGO / Auto Trading Software | Eco World Capital';
  }, []);

  const softwareOptions = [
    { title: 'Lease-based Trading Software', price: 'PRICING RANGE INR 25,000 TO 10,00,000' },
    {
      title: 'Rental Trading Software',
      price: 'PRICING RANGE INR 100 TO 10,000',
      priceBelowDetails: true,
      details: ['FOR ONE DAY INR 200.', 'FOR WEEK INR 600.', 'FOR MONTHS INR 2,500.'],
    },
    { title: 'Outright Software Purchase', price: 'PRICING INR 1,00,000 TO 5,00,000' },
    {
      title: 'Customized Trading Automation Solutions',
      price: 'ON REQUEST AND AFTER DETAILS REQUIREMENT PROVIDED TO US.',
      isNote: true,
    },
  ];

  const suitableMarkets = [
    'Equity Markets',
    'Futures & Options',
    'Commodities Markets',
    'Currency Markets',
    'International Financial Markets EA FOR MT4 & MT5.',
  ];

  return (
    <PageShell>
      {/* --- CUSTOM HERO SECTION WITH VIDEO --- */}
      <section className="relative overflow-hidden pt-50 pb-50 px-6 md:px-12 text-center z-10">
        {/* Background Video Container */}
        <div className="absolute inset-0 z-0 bg-black">
          
          {/* DESKTOP VIDEO: Hidden on mobile, shown on medium screens and up */}
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="hidden md:block w-full h-full object-cover"
          >
            <source src={heroVedio} type="video/mp4" />
          </video>

          {/* MOBILE VIDEO: Shown on mobile, hidden on medium screens and up */}
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="block md:hidden w-full h-full object-cover"
          >
            <source src={mobileHeroVedio} type="video/mp4" />
          </video>

          {/* Dark overlay to make text readable */}
          <div className="absolute inset-0 bg-black/60"></div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto relative z-10">
          <span className="section-badge">ECO WORLD CAPITAL (EWC)</span>
          <h1 className="mt-8 text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight drop-shadow-md">
            ALGO / Auto Trading Software Solutions
          </h1>
          <p className="mt-8 text-lg md:text-xl text-brand-cream-muted max-w-2xl mx-auto font-medium leading-relaxed drop-shadow-sm">
            We facilitate ALGO/AUTO TRADING SOFTWARE for Indian and Global Markets:
          </p>
        </div>
      </section>
      {/* -------------------------------------- */}

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
            {softwareOptions.map((option, idx) => (
              <div
                key={idx}
                className="glass-card p-8 shadow-[0_8px_30px_rgba(0,0,0,0.1)] hover:bg-brand-cream/20 hover:border-brand-gold-light/50 transition-all duration-300 shimmer-hover flex flex-col justify-between text-center"
              >
                <div className="relative z-10 flex flex-col h-full justify-between">
                  <div>
                    <div className="w-16 h-16 mx-auto bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-full flex items-center justify-center mb-6 shadow-inner text-brand-primary">
                      <Settings size={28} aria-hidden="true" />
                    </div>
                    <h3 className="text-xl font-extrabold text-brand-cream tracking-wide mb-4">{option.title}</h3>
                  </div>

                  <div className="mt-6 pt-6 border-t border-brand-cream/20">
                    {option.details && option.priceBelowDetails && (
                      <ul className="mb-4 space-y-2 text-left">
                        {option.details.map((detail, detailIdx) => (
                          <li key={detailIdx} className="text-sm font-extrabold text-brand-primary bg-brand-gold-light px-3 py-2 rounded-lg shadow-sm">
                            {detail}
                          </li>
                        ))}
                      </ul>
                    )}
                    <span
                      className={`inline-block bg-brand-cream text-brand-primary font-extrabold px-4 py-2 rounded-full shadow-md tracking-wider ${
                        option.isNote ? 'text-xs leading-snug' : 'text-sm'
                      }`}
                    >
                      {option.price}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-extrabold text-brand-cream drop-shadow-sm">Suitable for:</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {suitableMarkets.map((market, idx) => (
            <div
              key={idx}
              className="glass-card p-6 rounded-2xl hover:bg-brand-cream/20 hover:border-brand-gold-light/40 transition-all flex items-center space-x-4 shadow-md group"
            >
              <span className="text-brand-primary text-xl bg-gradient-to-br from-brand-gold to-brand-gold-light w-12 h-12 rounded-xl flex items-center justify-center shadow-inner font-black group-hover:scale-110 transition-transform shrink-0">
                ✦
              </span>
              <span className="text-base font-bold text-brand-cream tracking-wide block">{market}</span>
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
};

export default Algorithm;